"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    breadcrumbItemClassNames: function() {
        return breadcrumbItemClassNames;
    },
    useBreadcrumbItemStyles_unstable: function() {
        return useBreadcrumbItemStyles_unstable;
    }
});
const _react = require("@griffel/react");
const breadcrumbItemClassNames = {
    root: 'fui-BreadcrumbItem'
};
const useBreadcrumbItemResetStyles = /*#__PURE__*/ (0, _react.__resetStyles)("r1tl60rs", null, [
    ".r1tl60rs{display:flex;align-items:center;color:var(--colorNeutralForeground2);box-sizing:border-box;text-wrap:nowrap;}"
]);
const useBreadcrumbItemStyles_unstable = (state)=>{
    const resetStyles = useBreadcrumbItemResetStyles();
    state.root.className = (0, _react.mergeClasses)(breadcrumbItemClassNames.root, resetStyles, state.root.className);
    return state;
}; //# sourceMappingURL=useBreadcrumbItemStyles.styles.js.map
